import { render, staticRenderFns } from "./MarginFileImport.vue?vue&type=template&id=610b66d4&"
import script from "./MarginFileImport.vue?vue&type=script&lang=js&"
export * from "./MarginFileImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports